import { lazy } from 'react';

export const TeamMemberPage = lazy(() => import('./TeamMemberPage'));
